import { useQuery } from "@tanstack/react-query";
import { getOnboardingStatus } from "@/features/home/onboarding/onboarding.api";
import type { OnboardingStatus } from "@/features/home/onboarding/schemas/onboarding-status.schema";

export function useOnboardingStatus(workspaceId: string | undefined) {
  return useQuery<OnboardingStatus>({
    queryKey: ["onboarding", workspaceId] as const,
    queryFn: () => {
      if (!workspaceId) throw new Error("workspaceId required");
      return getOnboardingStatus(workspaceId);
    },
    enabled: Boolean(workspaceId),
    staleTime: 30_000,
  });
}
